/* globals jui, lp, editor */
var Rx   = require('ub_wrapped/rx');
var _    = require('lodash');
var rxUi = window.rxUi;

window.lp = window.lp || {};
window.lp.editor = window.lp.editor || {};

window.lp.editor.ElementPalletDnd = function(moduleType, button0, uiBinding) {
  var Source         = jui.dnd.Source;
  var pixelThreshold = window.jui.dnd.pixelThreshhold;

  var hint = new Element('span', {
    className: 'hint'
  }).update('click&nbsp;+&nbsp;hold&nbsp;to&nbsp;drag&nbsp;onto&nbsp;page');

  var _getWidgetForBlock = function(button, moduleType) {
    var DndGroup = lp.editor.dnd.sectionDnDGroup;
    var module   = lp.getModule(moduleType);

    return new Source(button, DndGroup, {
      type: moduleType,
      action: function(index) {
        module.addElementToPage(editor.page, {
          container: editor.page.getRootElement(),
          index:     index
        });
      }
    }, {
      centerGhost: true
    });
  };

  var _getWidgetForNonBlockElements = function(button, moduleType) {
    var DndGroup = lp.editor.dnd.elementDnDGroup;
    var module = lp.getModule(moduleType);

    return new Source(button, DndGroup, {
      type: moduleType,
      action: function(container, offset) {
        module.addElementToPage(editor.page, {
          container: container,
          offset:    offset,
          center:    moduleType === 'lp-pom-text' ? false : true,
          edit:      true
        });
      }
    }, {
      centerGhost: true
    });
  };

  var _registerRxUIEvents = function(widget, type, uiBinding) {
    var dragEvents = rxUi.observeDrag(widget.elm);
    var dragDropOrCancelEvents = dragEvents
      .filter(function(ev) {
        return ev.type === 'endDrag';
      })
      .map(function(ev) {
        var _isDraggedBeyondThreshold = (Math.abs(ev.startOffset.left - ev.pageX) >= pixelThreshold) ||
          (Math.abs(ev.startOffset.top - ev.pageY) >= pixelThreshold);
        var evType = _isDraggedBeyondThreshold ? 'dragDrop' : 'dragCancel';
        return _.merge(ev, {type: evType});
      });

    var mergedSourceEvents = Rx.Observable
      .merge(dragEvents, dragDropOrCancelEvents)
      .map(function(ev) {
        // Add in the module type for all events
        return _.merge(ev, {
          moduleType: type
        });
      });
    uiBinding.register(mergedSourceEvents);

    uiBinding.bindDOM(widget.elm, 'mouseout', 'deactivate');

    return uiBinding;
  };

  var _handler = function(ev0, widget0) {
    var dispatchTable = {
      startDrag: function(ev, widget) {
        if (! widget.elm.hasClassName('dsbl')) {
          widget.manager.startTracking(widget, ev, {
            usePrototypeBinding: false
          });
        }
      },

      drag: function(ev , widget) {
        if (! widget.elm.hasClassName('dsbl')) {
          window.jui.dnd.mouseMoveListener(ev);
        }
      },

      dragCancel: function(ev, widget) {
        window.jui.dnd.cancelDragOrDrop(true /* clear dragging flag */);
        var label = widget.elm.down('.widget-label');
        if (hint.parentNode === null) {
          label.insert(hint);
        }
      },

      dragDrop: function(ev /* , widget */) {
        window.jui.dnd.mouseUpListener(ev);
      },

      deactivate: function(/* ev , widget */) {
        if (hint.parentNode !== null) {
          hint.remove();
        }
      }
    };

    if (_.has(dispatchTable, ev0.type)) {
      dispatchTable[ev0.type](ev0, widget0);
    }
  };

  var main = function(moduleType, button, uiBinding) {
    var getWidget = moduleType === 'lp-pom-block' ? _getWidgetForBlock : _getWidgetForNonBlockElements;
    var widget = getWidget(button, moduleType);

    // Emit drag events from this widget to UI binding that was passed in
    _registerRxUIEvents(widget, moduleType, uiBinding);

    // Subscribe to those events, for this widget only
    uiBinding.sink
      .filter(function(ev) { return ev.moduleType === moduleType; })
      .ub_subscribe(_.partialRight(_handler, widget));
  };

  main(moduleType, button0, uiBinding);
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/element_pallet_dnd.js
// module id = 1006
// module chunks = 0